import { Dispatch } from 'redux';
import types from 'redux/actions/actionTypes';
import { axiosV2 } from 'interceptors/axios';

import { Folder } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';
import { ApiQueryParams } from 'types/ApiQueryParams';
import { updateSocietyData } from '../../society/redux/updateSocietyData';

type AddFolderProps = {
  folderData: Partial<Folder>;
};

type GetFoldersProps = {
  societyId: string;
  currentFolderId?: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

type FoldersApiAddResponse = {
  folder: Folder;
  foldersCount: {
    total: number;
  };
};

type FoldersApiUpdateResponse = {
  updatedFolder: Folder;
};

type FoldersApiGetAllResponse = {
  data: Folder[];
  total: number;
};

type UpdateFolderProps = {
  folderId: string;
  updateFolderData: Partial<Folder>;
};

type DeleteFolderProps = {
  folderId: string;
};

export const addFolder =
  ({ folderData }: AddFolderProps) =>
  async (dispatch: Dispatch) => {
    try {
      const body = { ...folderData };
      const { data } = await axiosV2.post('/folders', body);
      const decodedData = (await decryptResponse(
        data
      )) as FoldersApiAddResponse;

      dispatch({
        type: types.CREATE_FOLDER,
        folder: decodedData?.folder,
      });

      updateSocietyData(decodedData, dispatch);

      return decodedData?.folder;
    } catch (error) {
      dispatchError(error, dispatch);
      throw error;
    }
  };

export const getFolders =
  ({ societyId, currentFolderId, params = {}, signal }: GetFoldersProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/folders', {
        params: {
          societyId,
          currentFolderId,
          ...params,
        },
        // signal,
      });

      const decodedData = (await decryptResponse(
        data
      )) as FoldersApiGetAllResponse;

      dispatch({
        type: types.GET_FOLDERS,
        folders: decodedData.data,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const updateFolder =
  ({ folderId, updateFolderData }: UpdateFolderProps) =>
  async (dispatch: Dispatch) => {
    const body = { ...updateFolderData };

    const { data } = await axiosV2.put(`/folders/${folderId}`, body);

    const decodedData = (await decryptResponse(
      data
    )) as FoldersApiUpdateResponse;

    dispatch({
      type: types.UPDATE_FOLDER,
      folder: decodedData.updatedFolder,
    });
  };

export const deleteFolder =
  ({ folderId }: DeleteFolderProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.delete(`/folders/${folderId}`);
      const decodedData = await decryptResponse(data);

      updateSocietyData(decodedData, dispatch);

      dispatch({
        type: types.DELETE_FOLDER,
        folderId,
      });
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
